import { render, staticRenderFns } from "./iframe-page.vue?vue&type=template&id=162bd86c&scoped=true&"
import script from "./iframe-page.vue?vue&type=script&lang=js&"
export * from "./iframe-page.vue?vue&type=script&lang=js&"
import style0 from "./iframe-page.vue?vue&type=style&index=0&id=162bd86c&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162bd86c",
  null
  
)

export default component.exports